import styled from "styled-components";

import iconCalendar from "../../../assets/icons/icon-calendar-black.svg";
import ArrowDown from '../../../assets/icons/icons8-expand-arrow-32.png';
import { theme } from "../../../styles/theme";

export const Container = styled.div`
  width: 100%;
  height: auto;
  min-height: ${({ minHeight }) => minHeight || "auto"};
  margin-bottom: ${({ marginBottom }) => marginBottom || "0px"};

  gap: 0.25rem;
  display: flex;
  flex-direction: column;
`;

export const ContainerInputs = styled.div`
  position: relative;

  width: 100%;
  height: auto;

  gap: 0.25rem;
  display: flex;
  flex-direction: column;
`;

export const ContainerSelect = styled.div`
  position: relative;
  width: 100%;
  height: auto;
`;

export const Select = styled.select`
  width: 100%;
  height: 3rem;
  padding: 0.875rem 2.6875rem 0.875rem 1rem;
  
  display: flex;

  cursor: pointer;
  border-radius: ${({ radius }) => (radius ? "999px" : "8px")};
  background-color: ${({ disabled }) => disabled ? `${theme.colors.disabled.Fundo_Desabilitado}` : "#FFFFFF"};
  border: 1px solid ${({ hasError }) => (hasError ? "#FF5252 !important" : "#8A92A2")};

  font-weight: 400;
  color:  ${theme.colors.gray.Cinza_2};
  font-family: 'Lato';
  font-size: 0.875rem;
  line-height: 1.3125rem;

  appearance: none;
  -webkit-appearance: none;
  -moz-appearance: none;

  &:focus {
    border-color: ${({ hasError }) => (hasError ? "#FF5252 !important" : "#21262F")};
    outline: none;
  }

  &:disabled {
    color: #AAAAAA;
    border: 1px solid ${theme.colors.disabled.Desabilitado_Claro};
    background-color: ${theme.colors.disabled.Fundo_Desabilitado};
  }
`;

export const ArrowIcon = styled.span`
  pointer-events: none;

  top: 50%;
  right: 1rem;
  position: absolute;

  width: 1rem;
  height: 1rem;
  
  transform: translateY(-50%);
  
  transition: transform 0.3s ease; 

  background-size: contain;
  background-position: center;
  background-repeat: no-repeat;
  background-size: 1rem;
  background-image: url(${ArrowDown});
  background-color: #FFF;

  ${Select}:focus ~ & {
    transform: translateY(-50%) rotate(180deg);
  }

  ${Select}:not(:focus) ~ & {
    transform: translateY(-50%) rotate(0deg); 
  }
`;

export const Input = styled.input`
  width: 100%;
  height: 3rem;
  padding: ${({ searchLeft, type }) => (
    searchLeft ? "0.875rem 2.6875rem 0.875rem 2.5rem" :
      type === "datetime-local" ? "0.875rem 0.6875rem 0.875rem 1rem" : "0.875rem 2.6875rem 0.875rem 1rem")};

  border-radius: ${({ searchLeft }) => (searchLeft ? "2.5rem" : "0.5rem")};
  border: 1px solid ${({ hasError }) => (hasError ? `${theme.colors.red.Vermelho_erro}` : "#8A92A2")};
  background-color: ${theme.colors.white.Branco} !important;

  transition: 0.2s ease all;

  font-weight: 400;
  font-size: 0.875rem;
  font-family: 'Lato';
  line-height: 1.3125rem;
  color: ${({ hasError, type }) => (type === "datetime-local" ? "#21262F !important" : hasError ? "#FF5252 !important" : "#21262F !important")};

  cursor: text;

  &:focus {
    border-color: ${({ hasError }) => (hasError ? `${theme.colors.red.Vermelho_erro}` : "#21262F")};
  }

  &:disabled {
    cursor: not-allowed;

    color: #AAAAAA !important;
    border: 1px solid ${theme.colors.disabled.Desabilitado_Claro};
    background-color: ${theme.colors.disabled.Fundo_Desabilitado};
  }

  &:-webkit-autofill,
  &:-webkit-autofill:hover,
  &:-webkit-autofill:focus,
  &:-webkit-autofill:active {
      -webkit-box-shadow: 0 0 0 30px white inset !important;
      transition: background-color 600000s 0s !important;
      color: #21262F !important;
  }

  &[type="search"]::-webkit-search-cancel-button,
  &[type="search"]::-webkit-search-decoration {
    -webkit-appearance: none;
    appearance: none;
  }

  &[type="search"]::-ms-clear {
    display: none;
  }

  &[type="datetime-local"] {
    -webkit-appearance: none;
    appearance: none;

    background-color: #fff;
    color-scheme: light;
    font-size: 0.875rem;
    font-family: 'Lato';
    padding-right: 2.5rem;

     &::-webkit-calendar-picker-indicator {
        display: none;
    }
  }

  &[type="date"] {
    -webkit-appearance: none;
    appearance: none;

    background-color: #fff;
    color-scheme: light;
    font-size: 0.875rem;
    font-family: 'Lato';
    padding-right: 1.5rem;
  }
`;

export const Label = styled.label`
  left: ${({ searchLeft }) => (searchLeft ? "40px" : "12px")};
  position: absolute;
  top: ${({ isFocusedOrHasValue }) => (isFocusedOrHasValue ? '-0.5rem' : '0.8125rem')};

  width: auto;
  height: auto;
  padding: 0 0.25rem;

  gap: 2px;
  display: ${({ searchLeft, isFocusedOrHasValue }) => (searchLeft && isFocusedOrHasValue ? 'none' : 'flex')};

  border-radius: ${({ radius }) => (radius ? "999px" : "4px")};
  pointer-events: none;
  border-radius: 0.25rem;
  transition: 0.2s ease all;
  background-color: ${({ isDisabled }) => (isDisabled ? `${theme.colors.disabled.Fundo_Desabilitado}` : "#FFFFFF")};

  > span {
    font-weight: 400;
    text-align: left;
    font-family: 'Lato';
    color: ${({ isDisabled }) => (isDisabled ? "#AAAAAA" : `${theme.colors.red.Vermelho_erro}`)};
    font-size: ${({ isFocusedOrHasValue }) => (isFocusedOrHasValue ? "0.75rem" : "0.875rem")};
    line-height: ${({ isFocusedOrHasValue }) => (isFocusedOrHasValue ? "1.125rem" : "1.3125rem")};

    transition: 0.2s ease all;
  }

  > p {
    font-weight: 400;
    text-align: left;
    font-family: 'Lato';
    color: ${({ isDisabled }) => (isDisabled ? "#AAAAAA" : "#8A92A2")};
    font-size: ${({ isFocusedOrHasValue }) => (isFocusedOrHasValue ? "0.75rem" : "0.875rem")};
    line-height: ${({ isFocusedOrHasValue }) => (isFocusedOrHasValue ? "1.125rem" : "1.3125rem")};

    transition: 0.2s ease all;
  }
`;

export const LabelWithAsterisk = styled(Label)``;

export const DescriptionInput = styled.div`
  all: unset;

  padding: 0 1rem;

  gap: 0.25rem;
  display: flex;

  >p{
    font-weight: 400;
    font-size: 0.625rem;
    font-family: 'Lato';
    line-height: 0.9375rem;
    color: ${({ hasError, isDisabled }) => (hasError ? `${theme.colors.red.Vermelho_erro}` : isDisabled ? "#AAAAAA" : "#586377")};
  }
`

export const Placeholder = styled.div`
  left: 1rem;
  top: 0.875rem;
  position: absolute;
  left: ${({ searchLeft }) => (searchLeft ? "40px" : "")};

  padding: 0 0.3125rem;

  background: transparent;

  > span {
    color: #8A92A2;
    font-weight: 400;
    text-align: left;
    font-size: 0.75rem;
    font-family: 'Lato';
    line-height: 1.125rem;
    
    opacity: 0; 
    animation: ${({ isFocused }) => (isFocused ? "fadeIn 0.1s ease 0.1s forwards" : "none")};
  }

  @keyframes fadeIn {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }
`;

export const ClearButton = styled.button`
  position: absolute;
  top: ${({ hasError, extraInfo }) => (hasError ? "26px" : extraInfo ? "39%" : "26px")};
  right: ${({ type }) => (type === "password" ? "2.5rem" : "1rem")};

  padding-left: 0.375rem;
  
  color: #999;
  font-size: 1rem;

  border: none;
  cursor: pointer;
  background: none;
  background-color: #FFFFFF;
  
  transform: translateY(-50%);

  >span>img{
    width: 16px;
    height: auto;
  }

  &:hover {
    color: ${theme.colors.gray.Cinza_2};
  }
`;

export const YesNoContainer = styled.div`
  position: absolute;
  top: -0.5625rem;
  right: 0.75rem;
  z-index: 1;

  padding: 0 0.3125rem;

  display: ${({ hidden }) => (hidden ? "none" : "flex")};
  align-items: center;
  gap: 6px;

  background-color: #FFFFFF;

  span {
    font-weight: 700;
    font-family: 'Lato';
    font-size: 0.75rem;
    line-height: 1.125rem;
    color: ${({ disabled }) => (disabled ? "#AAAAAA" : "#586377")};
  }

  @media only screen and (max-width: 991px) {
    display: ${({ hidden, hideMobile }) => (hidden || hideMobile ? "none" : "flex")};
  }
`;

export const TogglePasswordButton = styled.button`
  right: 0.625rem;
  position: absolute;
  top: ${({ hasError }) => (hasError ? "26px" : "50%")};

  padding: 0;
  
  display: flex;
  align-items: center;
  justify-content: center;
  
  border: none;
  cursor: pointer;
  background: none;
  
  transform: translateY(-50%);

  img {
    width: 1.25rem;
    height: 1.25rem;
    margin-bottom: ${({ showPassword }) => (showPassword ? "0.1563rem" : "0")};
  }
`;

export const SearchButton = styled.button`
  top: 50%;
  /* right: 10px; */
  right: ${({ searchLeft }) => (searchLeft ? "" : "10px")};
  left: ${({ searchLeft }) => (searchLeft ? "16px" : "")};

  position: absolute;
  
  padding: 0;
  
  display: flex;
  align-items: center;
  justify-content: center;

  border: none;
  cursor: pointer;
  background: none;
  
  transform: translateY(-50%);

  img {
    width: 1.25rem;
    height: 1.25rem;
  }
`;

export const CalendarIconWrapper = styled.span`
    position: absolute;
    top: 50%;
    right: 0.5rem;

    width: 1.65rem;
    height: 1.25rem;

    background-image: url(${iconCalendar});
    background-repeat: no-repeat;
    background-size: contain;
    pointer-events: none;
    background-color: #FFFF;
    
    transform: translateY(-50%);
`;

export const FormattedValue = styled.div`
    top: 0.625rem;
    left: 0.625rem;
    position: absolute;

    width: 32%;
    height: 60%;

    display: flex;
    align-items: center;

    opacity: ${(props => props.hasValue ? "0" : "1")};
`;

export const EmptyValue = styled.div`
  top: 0.625rem;
  left: 0.625rem;
  position: absolute;

  height: 60%;
  width: 7.5rem;


  display: flex;
  align-items: center;

  background:rgb(255, 255, 255);

  opacity: ${(props => props.hasValue ? "0" : "1")};
`;